// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"9ea03849","163":"0126cd56","173":"3291a906","179":"8d44723d","355":"e396ae98","421":"94167595","436":"550e898b","461":"3d70759a","524":"0745bab1","535":"a9f83e9b","700":"d09bc44b","754":"360aa90e","797":"ac025399","946":"19325783","993":"53400c87"}[chunkId] + ".chunk.js";
};